import { useSnapshot } from "valtio";
import uiState from "../data";
import { motion, AnimatePresence } from "framer-motion";
import { windowSizeState } from "../utils/windowSize";
import { useState, useRef } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { googleSheet } from "../utils/getSheet";

const Homepage = ({ event }) => {
  const { visible } = useSnapshot(uiState[event]);
  const { mobileMode, phoneMode } = useSnapshot(windowSizeState);
  const [isScrollBottom, setIsScrollBottom] = useState(false);
  const scrollContainerRef = useRef();
  const data = googleSheet["homepage"].filter((el) => {
    return el.part === "first_page";
  })[0];

  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;

    if (scrollContainer) {
      const isAtBottom =
        scrollContainer.scrollHeight - scrollContainer.scrollTop <
        scrollContainer.clientHeight + 10;

      if (isAtBottom) {
        setIsScrollBottom(true);
      } else {
        setIsScrollBottom(false);
      }
    }
  };

  const scrollDownTextVariants = {
    show: {
      opacity: [0.2, 0.4, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "linear",
      },
      willChange: "transform",
      layout: "position",
    },
    hide: {
      opacity: [0],
    },
  };

  return (
    <>
      {visible && (
        <div className="screen-setting overflow-hidden absolute top-0 left-0">
          <img
            src="../startImages/bg/bg.jpg"
            alt="背景圖片"
            className="w-full h-full "
          />
        </div>
      )}

      <AnimatePresence>
        {visible && (
          <motion.div
            className="screen-setting overflow-hidden fixed top-0 left-0 z-[101]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <img
              src="../startImages/bg/bg.jpg"
              alt="背景圖片"
              className="w-full h-full "
            />
            <img
              src="../startImages/line/line1.png"
              alt="背景線"
              className=" absolute top-0 left-1/2 h-full -translate-x-1/2 "
            />
            <img
              src="../startImages/logo/color.png"
              alt="logo 彩色部分"
              className="absolute top-0 left-1/2 -translate-x-1/2 w-[50px] portraitPh:w-[40px] landscapePhone:w-[40px]"
            />
            <div className="absolute h-[75%] landscapePad:h-[80%] portraitPh:h-[85%] w-[800px] portraitPad:w-[85%] landscapePhone:w-[85%] top-1/2 -translate-y-1/2 left-1/2  -translate-x-1/2 flex flex-col items-center justify-between  ">
              <div>
                <img
                  src="../startImages/logo/big_logo.png"
                  alt="黑色 logo"
                  className="w-[240px] laptop:w-[220px] smallLaptop:w-[180px] landscapePad:w-[180px] portraitPh:w-[150px] landscapePhone:w-[120px] "
                />
              </div>
              <div className="text-center w-full tracking-wider whitespace-pre-wrap h-[40%] landscapePad:h-[40%] portraitBigPh:h-[50%] landscapePhone:h-[45%] ">
                <p className="Trajan text-[20px] mb-4 portraitPh:text-[17px] landscapePhone:text-[17px]">
                  {data.en_title1}
                </p>
                <div
                  className="h-[90%] portraitPh:h-[86%] landscapePhone:h-[60%]  overflow-y-auto pr-3 translate-x-[8px] infoScroll "
                  onScroll={handleScroll}
                  ref={scrollContainerRef}
                >
                  <i className=" text-[17px] portraitPh:text-[15px] landscapePhone:text-[15px]">
                    <ReactMarkdown
                      children={data.en_content1}
                      rehypePlugins={[rehypeRaw]}
                    />
                  </i>
                </div>
              </div>
              {phoneMode && (
                <>
                  {!isScrollBottom && (
                    <motion.div
                      className="jf  text-scrollText-100 text-[17px] flex overflow-hidden "
                      variants={scrollDownTextVariants}
                      initial="hide"
                      animate="show"
                    >
                      <p className="">{data.scrollTip}</p>
                    </motion.div>
                  )}

                  {isScrollBottom && (
                    <div className="box-border  h-[50px] flex justify-center portraitPh:h-[40px] landscapePhone:h-[40px]">
                      <button
                        className={`Trajan  border-mainOrange-100 px-7 portraitPh:px-5 landscapePhone:px-5 h-full py-[10px] portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2  bg-white ${
                          mobileMode ? "" : "hover:border-4"
                        } `}
                        onClick={() => {
                          uiState.enterPage.visible = true;
                          uiState.homepage.visible = false;
                          sessionStorage.clear();
                        }}
                      >
                        {data.en_btn1}
                      </button>
                    </div>
                  )}
                </>
              )}

              {!phoneMode && (
                <div className="box-border  h-[50px] flex justify-center portraitPh:h-[40px] landscapePhone:h-[40px]">
                  <button
                    className={`Trajan  border-mainOrange-100 px-7 portraitPh:px-5 landscapePhone:px-5 h-full py-[10px] portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2  bg-white ${
                      mobileMode ? "" : "hover:border-4"
                    } `}
                    onClick={() => {
                      uiState.enterPage.visible = true;
                      uiState.homepage.visible = false;
                      sessionStorage.clear();
                    }}
                  >
                    {data.en_btn1}
                  </button>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Homepage;
